/**
 * Datasets 목록 화면의 뷰 상태.
 *
 * 모달은 순수 표현 컴포넌트이고 상태는 페이지가 든다 — 열림 · 입력 · 제출 · 오류가 한 판별
 * 유니온에 모여 있어야 "닫혀 있는데 제출 중" 같은 조합이 타입에서 아예 생기지 않는다.
 */
export type RegisterFormState = {
  sourceRef: string;
  displayName: string;
  /** 사용자가 표시 이름을 직접 건드렸는지. 건드리기 전까지는 주소를 따라간다. */
  displayNameTouched: boolean;
};

export type RegisterFieldErrors = {
  sourceRef: string | null;
  displayName: string | null;
};

export const EMPTY_REGISTER_FIELD_ERRORS: RegisterFieldErrors = {
  sourceRef: null,
  displayName: null,
};

export type DatasetListDialogState =
  | { kind: "closed" }
  | {
      kind: "register";
      form: RegisterFormState;
      fieldErrors: RegisterFieldErrors;
      errorMessage: string | null;
      submitting: boolean;
    };

export const CLOSED_DIALOG: DatasetListDialogState = { kind: "closed" };

export function emptyRegisterDialog(): DatasetListDialogState {
  return {
    kind: "register",
    form: { sourceRef: "", displayName: "", displayNameTouched: false },
    fieldErrors: EMPTY_REGISTER_FIELD_ERRORS,
    errorMessage: null,
    submitting: false,
  };
}
